/**
 * Event handlers for Google Pay button interactions
 */

export class GooglePayEventHandlers {
  constructor(vueComponent, paymentService, stripeService) {
    this.vueComponent = vueComponent;
    this.paymentService = paymentService;
    this.stripeService = stripeService;
  }

  /**
   * Handle Google Pay button click event
   * @param {Object} event - click event from Stripe
   */
  handleClick(event) {
    // validate forms
    this.vueComponent.$v.form.deal.$touch();
    this.vueComponent.$v.form.variant.$touch();

    if (this.vueComponent.$v.form.deal.$invalid || this.vueComponent.$v.form.variant.$invalid) {
      setTimeout(() => this.vueComponent.scroll_to_error(), 100);
      return; // don't resolve, let it timeout
    }

    this.vueComponent.google_pay_error = null;
    this.vueComponent.is_submitted = true;
    event.resolve();
  }

  /**
   * Handle Google Pay payment confirmation event
   * @param {Object} event - confirm event from Stripe
   */
  async handleConfirm(event) {
    try {
      // create payment intent
      const paymentIntent = await this.paymentService.createPaymentIntent(this.vueComponent.form, this.vueComponent);
      if (!paymentIntent || !paymentIntent.client_key) {
        throw new Error('Failed to create payment intent');
      }

      // confirm payment
      const { error, paymentIntent: confirmedIntent } = await this.stripeService.confirmPayment(
        paymentIntent.client_key,
        window.location.href
      );

      if (error) {
        throw error;
      }

      // handle success
      this.handleSuccess(paymentIntent);

    } catch (error) {
      console.error('Google Pay payment error:', error);
      this.vueComponent.google_pay_error = error.message || this.vueComponent.t('checkout.payment_error');
      this.vueComponent.is_submitted = false;
    }
  }

  /**
   * Handle Google Pay cancellation event
   */
  handleCancel() {
    // handle Google Pay cancellation - unblock other payment buttons
    this.vueComponent.google_pay_error = null;
    this.vueComponent.is_submitted = false;
  }

  /**
   * Handle successful payment completion
   * @param {Object} paymentIntent - payment intent response
   */
  handleSuccess(paymentIntent) {
    this.paymentService.handlePaymentSuccess(
      paymentIntent,
      this.vueComponent.setDataToLocalStorage.bind(this.vueComponent),
      this.vueComponent.goto_upsells.bind(this.vueComponent)
    );
  }

  /**
   * Bind all event handlers to the Google Pay button
   */
  bindEvents() {
    this.stripeService.addEventListener('click', (event) => {
      this.handleClick(event);
    });

    this.stripeService.addEventListener('confirm', (event) => {
      this.handleConfirm(event);
    });

    this.stripeService.addEventListener('cancel', () => {
      this.handleCancel();
    });
  }
}

export default GooglePayEventHandlers;